<template>
  <div>
    <h3 class="mt-2 mb-4">Settings</h3>
    <h5>Notifications</h5>
    <div class="mt-4">
    <b-form-checkbox v-model="settings.notifications.email_sample_results"
      @change="saveUserPreferences"
      >Notify me when new sample results arrive.</b-form-checkbox
    >
    </div>
    
    <!-- Push Notifications Section -->
    <push-notification-settings class="mt-4" />
    <b-button to="/" class="mt-4" variant="primary">Finished</b-button>
  </div>
</template>

<script>
import PushNotificationSettings from '@/components/PushNotificationSettings'

export default {
  name: "Settings",
  components: {
    PushNotificationSettings
  },
  data() {
    return {
      settings: {
        notifications: { email_sample_results: false }
      },
    }
  },
  mounted() {
    this.fetchUserPreferences()
  },
  methods: {
    async fetchUserPreferences() {
      const url = process.env.VUE_APP_API_URI + "/user-preferences"
      const result = await this.axios.get(url)
      console.debug(result)
      if (result.data && result.data.notifications) {
        this.settings = result.data
      }
      console.debug(this.settings)
    },
    async saveUserPreferences() {
      try {
        const url = process.env.VUE_APP_API_URI + "/save-user-preferences"
        const result = await this.axios.post(url, this.settings)
        console.debug(result)
        if (result.status == 200) {
          this.$bvToast.toast('Settings saved successfully', {
            title: 'Success',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          })
        }
      } catch (error) {
        console.error('Error saving preferences:', error)
        this.$bvToast.toast('Failed to save settings', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        })
      }
    },
  }
}
</script>
